import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

import './assets/styles/tailwind.css';
import './assets/styles/app.scss';

const application = createApp(App);

application.use(createPinia());
application.use(router);

application.mount('#app');
